import { PayloadAction } from '@reduxjs/toolkit'
import { IProduct } from '@unfoldrtech/portal-mic'
import { WritableDraft } from 'immer/dist/internal'
import { ICampaign, IAdGroup } from '../../../models'
import { getSelectedAdGroup } from '../utils'

const addAdGroupProducts = (
  state: WritableDraft<ICampaign>,
  action: PayloadAction<{
    products: Array<IProduct>
    adGroupId: number
  }>
) => {
  const selectedAdGroup =
    getSelectedAdGroup(state, action.payload.adGroupId) || ({} as IAdGroup)

  const newProductList = [
    ...(selectedAdGroup.productList ?? []),
    ...action.payload.products,
  ]

  const productListIds = new Set(newProductList.map((p) => p.id))

  selectedAdGroup.productList = Array.from(productListIds).map((productId) => {
    return newProductList.find((p) => p.id === productId)!
  })
}

export default addAdGroupProducts
